import React from "react";
import TButton from "./TButton";
import TUploadImage from "./TUploadImage";
const Tbody = ({
  columns,
  rows,
  optionsRow,
  columnDelete,
  columnUploadImages,
  onDeleteRow,
  onChangeFieldColumn,
  componentsRows: TRowBody,
  render,
                 innerRef,
  ...props
}) => {
  if (typeof render === "function") {
    return (
      <tbody {...props} ref={innerRef}>
        {render(
          columns,
          rows,
          optionsRow,
          columnDelete,
          columnUploadImages,
          onDeleteRow,
          onChangeFieldColumn,
          render
        )}
      </tbody>
    );
  }

  return (
    <tbody>
      {rows.map((row) => {
        const values = columns.map((key) => [key, row[key]]);
        return (
          <TRowBody
            key={row._id}
            id={row._id}
            optionsRow={optionsRow}
            values={values}
            onChange={(key, value) => {
              onChangeFieldColumn(row._id, key, value);
            }}
          >
            {columnDelete ? (
              <TButton onEvent={() => onDeleteRow(row._id)} />
            ) : null}
            {columnUploadImages ? <TUploadImage uri={row.adminId} /> : null}
          </TRowBody>
        );
      })}
    </tbody>
  );
};

export default Tbody;



// WEBPACK FOOTER //
// ./src/new-components/admin/table/tbody.js